import { Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { Location } from "@angular/common";
import { filter } from "rxjs/operators";
import * as firebase from "firebase/app";
import "firebase/analytics";
import { Title } from "@angular/platform-browser";

declare const ga: any;

@Injectable()
export class AnalyticsService {
  private enabled: boolean;
  private analytics: any;

  constructor(
    private location: Location,
    private router: Router,
    private titleService: Title
  ) {
    this.enabled = true;
    this.analytics = firebase.default.analytics();
  }

  trackPageViews() {
    if (this.enabled) {
      this.router.events
        .pipe(filter((event) => event instanceof NavigationEnd))
        .subscribe(() => {
          console.log("AnalyticsService/trackPageViews:", this.location.path());
          // ga("send", { hitType: "pageview", page: this.location.path() });
          this.analytics.logEvent("send", {
            hitType: "pageview",
            page: this.location.path(),
          });
        });
    }
  }

  trackEvent(eventName: string) {
    if (this.enabled) {
      console.log("AnalyticsService/trackEvent:", eventName);
      // ga("send", "event", eventName);
      this.analytics.logEvent("send", "event", eventName);
    }
  }

  trackTitle(newTitle: string) {
    this.titleService.setTitle(`KaSoft - SGEdtech - ${newTitle}`);
    this.analytics.logEvent("send", "title", newTitle);
  }
}
